import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguage } from "../../redux/slices/changeLang";
import ImportFromCsv from "./importFromCsv";
import ErrorWrapper from "../wrapper/ErrorWrapper";

const Wrapper = () => {
  const lang = useSelector((state) => state.changeLang.language);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLanguage());
  }, []);

  if (!lang) {
    return null;
  } else if (window.location.toString().includes("/csv-import")) {
    return (
      <ErrorWrapper>
        <ImportFromCsv />
      </ErrorWrapper>
    );
  }

  return null;
};

export default Wrapper;
